import './Chip.less';
import { PropsWithChildren } from 'preact/compat';
import { IconId } from '../icon/icons';
import Icon from '../icon/Icon';

export type ChipProps = PropsWithChildren<{
    className?: string;
    startIconId?: IconId;
    startIconColor?: string;
    variant?: 'contained' | 'special' | 'white-special' | 'primary-50';
    onClick?: (event: MouseEvent) => void;
    size?: 'small' | 'medium';
}>;

const Chip = ({
    className = '',
    startIconId,
    startIconColor,
    children,
    variant = 'contained',
    size = 'medium',
    onClick
}: ChipProps) => (
    <div
        className={`bri-Chip ${className} bri-Chip-variant-${variant} ${
            onClick ? 'bri-clickable' : ''
        } bri-Chip-size-${size} ${
            size === 'small' ? 'bri-BodySmallFont' : 'bri-DisplayFont'
        }`}
        onClick={onClick}
        role={onClick ? 'button' : undefined}
        tabindex={onClick ? 0 : undefined}
        style={{
            ...(startIconColor && {
                '--bri-chip-start-icon-color': startIconColor
            })
        }}
    >
        {startIconId && (
            <Icon
                size="x-small"
                iconId={startIconId}
                className="bri-Chip-start-icon"
            />
        )}
        <span className={'bri-Chip-text'}>{children}</span>
    </div>
);

export default Chip;
